import { create } from 'zustand';

import {
  CDefaultLocale,
  ELocales,
  STORE_LOCALE_KEY,
  isRtlLocale,
} from '@common/types';

type TLocaleState = {
  locale: ELocales;
  setLocale: (locale: ELocales) => void;
};

const readInitialLocale = (): ELocales => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return CDefaultLocale;
  }
  const stored = window.localStorage.getItem(
    STORE_LOCALE_KEY,
  ) as ELocales | null;
  return stored && Object.values(ELocales).includes(stored)
    ? stored
    : CDefaultLocale;
};

const localeStore = create<TLocaleState>((set) => ({
  locale: readInitialLocale(),
  setLocale: (locale: ELocales) => set({ locale }),
}));

export const isCurrentLocaleRtl = (locale: ELocales): boolean =>
  isRtlLocale(locale);

export const useLocale = () => {
  const locale = localeStore((state) => state.locale);
  const setLocale = localeStore((state) => state.setLocale);
  return { locale, setLocale };
};
